<template>
  <div class="col-md-12 sim-task_list">
<!--    <div-->
<!--        class="main_filters"-->
<!--        :class="(filters_state)? 'main_fiters_toggler&#45;&#45;active' : 'main_fiters_toggler'"-->
<!--        @click="toggleFiltersState"-->
<!--    >-->
<!--      <span-->
<!--          class="mdi"-->
<!--          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"-->
<!--          @click="toggleFiltersState"-->
<!--      />-->
<!--      <span class="main_fiters_toggler_text">-->
<!--        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}-->
<!--      </span>-->
<!--    </div>-->

<!--    <div class="wrap-device-list_bg">-->
<!--      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">-->
<!--        <div class="form_select">-->
<!--          <tree-select-->
<!--              :options="target_list"-->
<!--              :multiple="false"-->
<!--              v-model="filter.target_result"-->
<!--              :placeholder="translate('task_types.task_list.target_result')"-->
<!--              :clearable="true"-->
<!--              @input="change_input"-->
<!--          />-->
<!--        </div>-->

<!--        <div class="form_select">-->
<!--          <tree-select-->
<!--              :options="status_list"-->
<!--              :multiple="false"-->
<!--              v-model="filter.status"-->
<!--              :placeholder="translate('task_types.task_list.status')"-->
<!--              :clearable="true"-->
<!--              @input="change_input"-->
<!--          />-->
<!--        </div>-->

<!--        <div class="form_select"></div>-->
<!--        <div class="form_select"></div>-->
<!--        <div class="form_select"></div>-->

<!--        <span-->
<!--            class="mdi mdi-plus-circle-outline btn btn-success btn-fill"-->
<!--            @click.prevent="create_sim_task"-->
<!--        >-->
<!--          <b>{{ translate('task_types.task_list.create_sim_task') }}</b>-->
<!--        </span>-->
<!--      </div>-->
<!--    </div>-->

    <div class="response_table">
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col">
              {{ translate('sim_task_list.task_types.code') }}
            </th>
            <th scope="col">
              {{ translate('sim_task_list.task_types.name') }}
            </th>
            <th scope="col">
              {{ translate('sim_task_list.task_types.allowed_oper_accounts') }}
            </th>
            <th scope="col">
              {{ translate('sim_task_list.task_types.handler') }}
            </th>
            <th scope="col">
              {{ translate('sim_task_list.task_types.target_result') }}
            </th>
            <th scope="col">
              {{ translate('sim_task_list.task_types.is_visible_in_simcard_profile') }}
            </th>
            <th scope="col">
              {{ translate('sim_task_list.task_types.is_default') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <SimTaskListItem
              v-for="(type,key) in task_types"
              :key="key"
              :type="type"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TaskTypesItem from "./Item/TaskTypesItem.vue";

export default {
  name: 'TaskTypes',
  components: {
    SimTaskListItem: TaskTypesItem
  },
  data () {
    return {
      task_types: [],
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      // filter:{
      //   target_result: null,
      //   status: null
      // }
    }
  },

  computed:{
    // sended_filter(){
    //   let filter = []
    //   Object.keys(this.filter).forEach((item) => {
    //     if (this.filter[item] !== null && this.filter[item] !== undefined && this.filter[item] !== ""){
    //       filter[item] = this.filter[item]
    //     }
    //   })
    //   return filter
    // },
    // target_list(){
    //   return []
    // },
    // status_list(){
    //   return []
    // },
  },

  watch:{

  },

  created () {
    this.get_task_types()
  },

  methods: {
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_task_types, 200)
    },
    get_task_types(){
      this.$http.simcard.getTaskTypes({}, (response) => {
        if (response.data){
          this.task_types = response.data
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },

    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>

.sim-task_list{
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .main_filters{
    top: 20px;
  }
  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .filter{
      margin: 0;
    }
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .search_user{
        margin-bottom: 0;
        width: 100%;
      }
      .btn{
        width: 30%;
      }
    }
    .form_select{
      flex: 1;
      .vue-treeselect{
        margin-bottom: 0;
      }
    }
  }

  .response_table{
    flex: 10;
    padding-left: 0;
    padding-right: 0;

    ::v-deep th,
    ::v-deep td{
      font-size: 12px;
    }

    ::v-deep .text-left{
      text-align: left;
    }

    .level{
      display: inline-block;
      width: 20px;
      height: 100%;
    }
    .w180{
      max-width: 180px;
      width: 180px;
    }
    .w100{
      max-width: 100px;
      width: 100px;
    }
    .has_child{
      background-color: #eee;
      font-weight: bold;
    }
    .name{
      text-align: left;
    }
    .inn{
      text-align: left;
    }
  }
}

@media (max-width: 1200px) {
  .projects_list{
    .response_table{
      .w180{
        max-width: none;
        width: auto;
      }
      .w100{
        max-width: none;
        width: auto;
      }
    }
  }
}

@media (max-width: 500px){
  .header{
    .form{
      width: 100%;
      .filter{
        min-width: max-content;
        margin: 0 10px;
      }
    }
    .btn{
      b{
        display: none;
      }
      width: 20%;
      min-width: inherit;
    }
    .search_user{
      width: 80%;
    }
  }

}
</style>
